
import PageHero from "./PageHero";
import img13 from "../../media/images/garary/FH_UG-516.jpg";
import { FaUtensils, FaCoffee, FaGlassCheers } from "react-icons/fa";
import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

function Dining() {
  const [show, setShow] = useState(false);

const handleClose = () => setShow(false);
const handleShow = () => setShow(true);
  const diningOptions = [
    {
      title: "Restaurant",
      desc: "Enjoy freshly prepared meals in a calm and welcoming environment.",
      icon: <FaUtensils />,
    },
    {
      title: "Breakfast",
      desc: "Start your day with a healthy and energizing breakfast.",
      icon: <FaCoffee />,
    },
    {
      title: "Special Events",
      desc: "Catering services available for weddings and special occasions.",
      icon: <FaGlassCheers />,
    },
  ];

  return (
    <>
      {/* HERO */}
      <PageHero
        title="Dining"
        subtitle="Experience delicious meals at Father’s House Church Resort Hotel"
        image={img13}
      />

      {/* INTRO */}
      <div className="container py-5 text-center">
        <h2 data-aos="fade-up">A Taste of Excellence</h2>
        <p className="mt-3" data-aos="fade-up">
          Our dining experience combines quality ingredients, skilled chefs,
          and a peaceful atmosphere to give you meals you will always remember.
        </p>
      </div>

      {/* DINING CARDS */}
      <div className="container pb-5">
        <div className="row">
          {diningOptions.map((item, index) => (
            <div
              className="col-md-4 mb-4"
              key={index}
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <div className="card shadow h-100 text-center p-4">
                <div className="text-success mb-3" style={{ fontSize: "40px" }}>
                  {item.icon}
                </div>
                <h5>{item.title}</h5>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* MENU PREVIEW */}
      <div className="bg-light py-5">
        <div className="container text-center">
          <h2 className="mb-5" data-aos="fade-up">
            Our Menu Highlights
          </h2>

          <div className="row">
            <div className="col-md-4 mb-4" data-aos="fade-up">
              <div className="p-4 bg-white shadow rounded">
                <h5>Local Dishes</h5>
                <p>Enjoy traditional meals prepared with local ingredients.</p>
              </div>
            </div>

            <div
              className="col-md-4 mb-4"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="p-4 bg-white shadow rounded">
                <h5>International Cuisine</h5>
                <p>A variety of global dishes to suit every taste.</p>
              </div>
            </div>

            <div
              className="col-md-4 mb-4"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="p-4 bg-white shadow rounded">
                <h5>Healthy Options</h5>
                <p>Fresh and nutritious meals for a balanced lifestyle.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div
        className="text-white text-center py-5"
        style={{
          backgroundImage: `url(${img13})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div style={{ background: "rgba(0,0,0,0.6)", padding: "40px" }}>
          <h2 data-aos="fade-up">Ready to Enjoy Our Meals?</h2>
          <p data-aos="fade-up" className="mt-2">
            Visit our restaurant and experience quality dining today.
          </p>
          <Button
             variant="success"
               className="mt-3"
               onClick={handleShow}
                  data-aos="fade-up">
              Reserve a Table
           </Button>  
        </div>
      </div>
      <Modal show={show} onHide={handleClose} centered>
  <Modal.Header closeButton>
    <Modal.Title>Reserve a Table</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <form>
      <div className="mb-2">
        <label className="form-label">Full Name</label>
        <input type="text" className="form-control" />
      </div>

      <div className="mb-2">
        <label className="form-label">Email</label>
        <input type="email" className="form-control" />
      </div>

      <div className="mb-2">
        <label className="form-label">Phone Number</label>
        <input type="text" className="form-control" />
      </div>

      <div className="mb-2">
        <label className="form-label">Date</label>
        <input type="date" className="form-control" />
      </div>

      <div className="mb-2">
        <label className="form-label">Time</label>
        <input type="time" className="form-control" />
      </div>

      <div className="mb-2">
        <label className="form-label">Number of Guests</label>
        <input type="number" className="form-control" />
      </div>
    </form>
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={handleClose}>
      Close
    </Button>
    <Button variant="success">
      Confirm Reservation
    </Button>
  </Modal.Footer>
</Modal>
    </>
  );
}

export default Dining;